import { afterNextRender, DestroyRef, Directive, ElementRef, NgZone, inject, signal } from '@angular/core';

@Directive({
    selector: '[spLineClamp]',
    standalone: true,
    exportAs: 'spLineClamp',
})
export class SpLineClampDirective {
    private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly ngZone = inject(NgZone);
    private readonly destroyRef = inject(DestroyRef);

    public readonly isOverflowing = signal(false);

    constructor() {
        afterNextRender(() => {
            this.checkOverflow();

            this.ngZone.runOutsideAngular(() => {
                const resizeObserver = new ResizeObserver(() => this.checkOverflow());
                resizeObserver.observe(this.elementRef.nativeElement);
                this.destroyRef.onDestroy(() => resizeObserver.disconnect());
            });
        });
    }

    private checkOverflow(): void {
        const el = this.elementRef.nativeElement;
        this.isOverflowing.set(el.scrollHeight - el.clientHeight > 1);
    }
}
